import { useState, useEffect, useCallback, useMemo } from 'react';
import { fetchActiveMenuWithCategoriesAndItems } from '../utils/dataService';
import { useAuth0 } from '@auth0/auth0-react';

// Custom hook to fetch menu data
export const useMenuData = (venueId) => {
  const { getAccessTokenSilently } = useAuth0();
  const [menu, setMenu] = useState({ menuId: null, categories: [] });

  const fetchMenuData = useCallback(async () => {
    const data = await fetchActiveMenuWithCategoriesAndItems(venueId, getAccessTokenSilently);
    const nextMenu = data || { menuId: null, categories: [] };
    setMenu(nextMenu);
    return nextMenu;
  }, [venueId, getAccessTokenSilently]);

  useEffect(() => {
    fetchMenuData();
  }, [fetchMenuData]);

  return useMemo(() => ({
    ...menu,
    refreshMenu: fetchMenuData,
  }), [fetchMenuData, menu]);
};
